<app-header *ngIf="!(cacherEntete$ | async)"></app-header>
<sigt-menus *ngIf="!(cacherEntete$ | async) && !(isCarteLegere$ | async)"></sigt-menus>
<div class="app-body"
    [ngClass]="{'app-body-mobile': isMobile(), 'isCarteLegere': isCarteLegere$ | async}">
    <router-outlet></router-outlet>
</div>
<sigt-chargement-en-cours></sigt-chargement-en-cours>